import { EpimsBaseEntityDto } from './epim-base.dto';
import { AreaOfImpactDto } from './areaofimpact.dto';
import { ImpactedCommunityDto} from './impactedcommunity.dto';
import {ImpactedAssetDto} from './impactedasset.dto';
import { AreaMapOfSpillDto } from '@cradua/data';

export class IncidentDto extends EpimsBaseEntityDto {

  IncidentNotificationId: string;
  IncidentName: string;
  IncidentDate: Date;
  JIVDate: Date;
  IncidentCategoryId: string;
  FacilityAssetId: string;
  LocationOfIncident: string;
  CauseOfIncident: string;
  TotalAreaOfImpact: number;
  UomId: string;
  CreatedPersonId: string;
  CreatedDate: Date;
  IncidentSerialNo: string;
  ApprovalRemarks: string;
  ApprovalDate: Date;
  ApprovalPersonId: string;
  ApprovalPersonName: string;
  NatureOfPolution: string;
  IncidentQuantumId: string;
  QtySpilled: number;
  QtyUOM: string;
  ReportedDate: Date;
  JIVSurveyDate: Date;
  Easting: number;
  Northing: number;
  QtyVolRecovered: number;
  CleanUpStatusId: string;
  ArchiveStatus: string;
  IncidentSubCategoryId: string;
  IncidentTypeStatus: string;
  IncidentEntryStatus: string;
  length: number;
  QtyRecoveredUOM: string;
  Remarks: string;
  // Version: number;
  areaofimpacts:AreaOfImpactDto[];
  areaofspills:AreaMapOfSpillDto[];
  impactedcommunitys:ImpactedCommunityDto[];
  impactedassets:ImpactedAssetDto[];
}
